module.exports = __webpack_public_path__ + "assets/img/paid.bc9b392e.png";